var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Favorite"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5625,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    fill: "#EBEBEB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6135 7.95H10.0539C8.91026 7.95 8.0125 8.87746 8.0125 10.0545V19.9258C8.0125 21.1022 8.90965 22.05 10.0539 22.05H19.6135C20.7574 22.05 21.665 21.1026 21.665 19.9258V10.0545C21.665 8.87712 20.7568 7.95 19.6135 7.95ZM20.4143 19.9258C20.4143 20.3722 20.0447 20.7354 19.6135 20.7354H10.0539C9.62344 20.7354 9.26318 20.373 9.26318 19.9258V10.0545C9.26318 9.60885 9.62192 9.26461 10.0539 9.26461H19.6135C20.0463 9.26461 20.4143 9.60961 20.4143 10.0545V19.9258Z",
    fill: "#676767",
    stroke: "#676767",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.2193 12.9363H13.7801C13.4269 12.9363 13.1355 13.1923 13.1355 13.5617C13.1355 13.9311 13.4269 14.187 13.7801 14.187H18.2193C18.5725 14.187 18.8639 13.9311 18.8639 13.5617C18.8639 13.1923 18.5725 12.9363 18.2193 12.9363Z",
    fill: "#676767",
    stroke: "#676767",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5716 14.2279C11.929 14.2279 12.2161 13.9291 12.2161 13.564C12.2161 13.1988 11.929 12.9001 11.5716 12.9001C11.2141 12.9001 10.9271 13.1988 10.9271 13.564C10.9271 13.9291 11.2141 14.2279 11.5716 14.2279Z",
    fill: "#676767",
    stroke: "#676767",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.2193 15.3016H13.7801C13.4233 15.3016 13.1355 15.5931 13.1355 15.9589C13.1355 16.3247 13.4233 16.6162 13.7801 16.6162H18.2193C18.5761 16.6162 18.8639 16.3247 18.8639 15.9589C18.8639 15.5931 18.5761 15.3016 18.2193 15.3016Z",
    fill: "#676767",
    stroke: "#676767",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.5716 16.6424C11.929 16.6424 12.2161 16.3436 12.2161 15.9785C12.2161 15.6134 11.929 15.3146 11.5716 15.3146C11.2141 15.3146 10.9271 15.6134 10.9271 15.9785C10.9271 16.3436 11.2141 16.6424 11.5716 16.6424Z",
    fill: "#676767",
    stroke: "#676767",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.2193 17.7308H13.7801C13.4233 17.7308 13.1355 18.0223 13.1355 18.3881C13.1355 18.7539 13.4233 19.0454 13.7801 19.0454H18.2193C18.5761 19.0454 18.8639 18.7539 18.8639 18.3881C18.8639 18.0223 18.5761 17.7308 18.2193 17.7308Z",
    fill: "#676767",
    stroke: "#676767",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.5716 19.0571C11.929 19.0571 12.2161 18.7583 12.2161 18.3932C12.2161 18.0281 11.929 17.7293 11.5716 17.7293C11.2141 17.7293 10.9271 18.0281 10.9271 18.3932C10.9271 18.7583 11.2141 19.0571 11.5716 19.0571Z",
    fill: "#676767",
    stroke: "#676767",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.2195 10.5071H11.3101C10.9534 10.5071 10.6656 10.7986 10.6656 11.1644C10.6656 11.5303 10.9533 11.8217 11.3101 11.8217H18.2196C18.5763 11.8217 18.8641 11.5303 18.8641 11.1644C18.864 10.7986 18.5763 10.5071 18.2195 10.5071Z",
    fill: "#676767",
    stroke: "#676767",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.5625,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "#EBEBEB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.26b81d6aa16d1336b7c57a6d80ad6420.svg";
export { ForwardRef as ReactComponent };